import type { InvestmentSpecCommandData } from '@festina/unitlink-general-types/unitlink'
import { FormikForm } from '@festina-life/ui/formikForms'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { SubPortfolioKeyInputs } from '../switchTrade/SubPortfolioKeyInputs'

const initialValues: InvestmentSpecCommandData = {
  _type: 'InvestmentSpecCommandData',
}
export const InvestmentSpecForm = (
  props: CommandDataFormProps<InvestmentSpecCommandData>,
) => (
  <FormikForm initialValues={initialValues} {...props}>
    <SubPortfolioKeyInputs />
  </FormikForm>
)
